// TODO: remove this in favor of real value types.
// This is just temporary helper to force atom configs to have all string values.
export function convertLegacyStyleValueToString(
  entry: [LonghandId, any]
): [LonghandId, string] {
  const property: LonghandId = entry[0];
  const value = entry[1];

  switch (property) {
    case 'backgroundColor':
    case 'borderBottomColor':
    case 'borderLeftColor':
    case 'borderRightColor':
    case 'borderTopColor':
    case 'outlineColor':
    case 'color':
      if (
        typeof value.r === 'number' &&
        typeof value.g === 'number' &&
        typeof value.b === 'number' &&
        typeof value.a === 'number'
      ) {
        return [
          property,
          `rgba(${value.r}, ${value.g}, ${value.b}, ${value.a})`,
        ];
      } else {
        return [property, value];
      }
    default:
      return [property, value];
  }
}

// NOTE: It is important that this is frozen because it allows flow to infer $Values correctly when deriving types.
export const LONGHAND_TO_CSS_PROPERTY = Object.freeze({
  appearance: 'appearance',
  alignContent: 'align-content',
  alignItems: 'align-items',
  alignSelf: 'align-self',
  aspectRatio: 'aspect-ratio',
  justifySelf: 'justify-self',
  backfaceVisibility: 'backface-visibility',
  background: 'background',
  backgroundColor: 'background-color',
  backgroundImage: 'background-image',
  backgroundPosition: 'background-position',
  backgroundSize: 'background-size',
  backgroundRepeat: 'background-repeat',
  backgroundAttachment: 'background-attachment',
  borderWidth: 'border-width',
  borderStyle: 'border-style',
  borderColor: 'border-color',
  borderTopWidth: 'border-top-width',
  borderTopStyle: 'border-top-style',
  borderTopColor: 'border-top-color',
  borderRightWidth: 'border-right-width',
  borderRightStyle: 'border-right-style',
  borderRightColor: 'border-right-color',
  borderBottomWidth: 'border-bottom-width',
  borderBottomStyle: 'border-bottom-style',
  borderBottomColor: 'border-bottom-color',
  borderLeftWidth: 'border-left-width',
  borderLeftStyle: 'border-left-style',
  borderLeftColor: 'border-left-color',
  borderRadius: 'border-radius',
  borderBottomLeftRadius: 'border-bottom-left-radius',
  borderBottomRightRadius: 'border-bottom-right-radius',
  borderTopLeftRadius: 'border-top-left-radius',
  borderTopRightRadius: 'border-top-right-radius',
  bottom: 'bottom',
  boxShadow: 'box-shadow',
  boxSizing: 'box-sizing',
  clear: 'clear',
  color: 'color',
  columnCount: 'column-count',
  columnGap: 'column-gap',
  columnRuleColor: 'column-rule-color',
  columnRuleStyle: 'column-rule-style',
  columnRuleWidth: 'column-rule-width',
  columnSpan: 'column-span',
  content: 'content',
  cursor: 'cursor',
  direction: 'direction',
  display: 'display',
  filter: 'filter',
  flexDirection: 'flex-direction',
  flexBasis: 'flex-basis',
  flexGrow: 'flex-grow',
  flexShrink: 'flex-shrink',
  flexWrap: 'flex-wrap',
  float: 'float',
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSmoothing: 'font-smoothing',
  fontStyle: 'font-style',
  fontWeight: 'font-weight',
  gridArea: 'grid-area',
  gridAutoFlow: 'grid-auto-flow',
  gridAutoColumns: 'grid-auto-columns',
  gridAutoRows: 'grid-auto-rows',
  gridColumnGap: 'grid-column-gap',
  gridRowGap: 'grid-row-gap',
  gridTemplateAreas: 'grid-template-areas',
  gridTemplateColumns: 'grid-template-columns',
  gridTemplateRows: 'grid-template-rows',
  gridColumnStart: 'grid-column-start',
  gridColumnEnd: 'grid-column-end',
  gridRowStart: 'grid-row-start',
  gridRowEnd: 'grid-row-end',
  height: 'height',
  justifyContent: 'justify-content',
  justifyItems: 'justify-items',
  left: 'left',
  letterSpacing: 'letter-spacing',
  lineHeight: 'line-height',
  listStyleType: 'list-style-type',
  marginBottom: 'margin-bottom',
  marginLeft: 'margin-left',
  marginRight: 'margin-right',
  marginTop: 'margin-top',
  maxHeight: 'max-height',
  maxWidth: 'max-width',
  minHeight: 'min-height',
  minWidth: 'min-width',
  objectFit: 'object-fit',
  objectPosition: 'object-position',
  opacity: 'opacity',
  order: 'order',
  outlineColor: 'outline-color',
  outlineOffset: 'outline-offset',
  outlineStyle: 'outline-style',
  outlineWidth: 'outline-width',
  overflow: 'overflow',
  overflowX: 'overflow-x',
  overflowY: 'overflow-y',
  paddingBottom: 'padding-bottom',
  paddingLeft: 'padding-left',
  paddingRight: 'padding-right',
  paddingTop: 'padding-top',
  perspective: 'perspective',
  perspectiveOrigin: 'perspective-origin',
  pointerEvents: 'pointer-events',
  position: 'position',
  right: 'right',
  textAlign: 'text-align',
  textDecoration: 'text-decoration',
  textIndent: 'text-indent',
  textOverflow: 'text-overflow',
  textShadow: 'text-shadow',
  textTransform: 'text-transform',
  textStrokeWidth: '-webkit-text-stroke-width',
  textStrokeColor: '-webkit-text-stroke-color',
  textUnderlineOffset: 'text-underline-offset',
  textDecorationThickness: 'text-decoration-thickness',
  textDecorationStyle: 'text-decoration-style',
  textDecorationColor: 'text-decoration-color',
  textDecorationSkipInk: 'text-decoration-skip-ink',
  textUnderlinePosition: 'text-underline-position',
  top: 'top',
  transform: 'transform',
  transformOrigin: 'transform-origin',
  transformStyle: 'transform-style',
  transition: 'transition',
  transitionProperty: 'transition-property',
  transitionDuration: 'transition-duration',
  transitionTimingFunction: 'transition-timing-function',
  transitionDelay: 'transition-delay',
  verticalAlign: 'vertical-align',
  visibility: 'visibility',
  WebkitOverflowScrolling: '-webkit-overflow-scrolling',
  whiteSpace: 'white-space',
  width: 'width',
  wordBreak: 'word-break',
  zIndex: 'z-index',
});

export type LonghandId = keyof typeof LONGHAND_TO_CSS_PROPERTY;
export type CSSProperty =
  (typeof LONGHAND_TO_CSS_PROPERTY)[keyof typeof LONGHAND_TO_CSS_PROPERTY];
